<template>
  <div class="b-filter b-filter--scroll">
    <div>
      <ul class="b-filter__items">
        <li
          v-for="filter in filtersData"
          :key="filter.id"
          class="b-filter__item"
          :class="selectedFilter === filter.key ? 'active' : ''">
          <label>
            <input
              v-model="selectedFilter"
              type="radio"
              name="filters"
              :value="filter.key"
              @change="changeDuration" />
            {{ filter.label }}
          </label>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    filtersData: {
      required: true,
      type: Object,
    },
    activeFilter: {
      required: true,
      type: String,
    },
  },
  emits: ['changed-duration'],
  data() {
    return {
      selectedFilter: '',
    }
  },
  watch: {
    activeFilter(newVal) {
      this.selectedFilter = newVal
    },
  },
  mounted() {
    this.elem = jQuery(this.$el)

    this.selectedFilter = this.activeFilter
  },
  methods: {
    changeDuration() {
      this.$emit('changed-duration', this.selectedFilter)
    },
  },
}
</script>
